import { render, staticRenderFns } from "./ConnectionRequests.vue?vue&type=template&id=cedfe00a"
import script from "./ConnectionRequests.vue?vue&type=script&lang=js"
export * from "./ConnectionRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports